// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".navbar-menu .el-menu--horizontal {\n  width: auto;\n  border: none !important;\n}\n.navbar-menu .el-submenu__title {\n  height: 28px !important;\n  line-height: 28px !important;\n  border-bottom: none !important;\n}\n.navbar-menu-popper .el-menu-item a {\n  font-size: 14px;\n  display: block;\n}\n", ""]);
// Exports
module.exports = exports;
